import * as yup from 'yup';

yup.setLocale({
    mixed: {
        required: 'تکمیل این فیلد الزامی می باشد',
    },
});

export default yup;
